import React from 'react'

import * as S from './styled'

const TitlePage = ({ text }) => <S.TitleElement>{text}</S.TitleElement>

export default TitlePage
